module.exports = __webpack_public_path__ + "static/media/fission.60ef8bb3.less";